import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CompleteData } from 'cbc-shared-lib';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CompleteDataService } from '../services/complete-data.service';

/**
 * 共通完了画面
 * @example
 * CompleteDataServiceをDIして画面情報を設定し、本コンポーネントに遷移する
 * 
 *【呼び出し元】
 * constructor(private CompleteDataService completeDataService) { }
 * 
 * this.completeDataService.completeData = {
 *   title: '新規お客さま登録完了',       // 画面タイトルを設定
 *   message: '新規お客さま登録しました', // 画面に表示するメッセージを設定
 *   next: '/sgkz001d',                      // OK押下時に遷移する画面
 *   koumokuList: [                     // 画面に表示したい情報（複数設定可）
 *     { label: '受付番号', val: 'response.aceptInfo.aceptNo' },
 *     { label: 'label', val: 'val' },
 *   ],
 * }
 * this.router.navigate(['/sgkz003d/']);
 * @export
 * @class Sgkz003dComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-sgkz003d',
  templateUrl: './sgkz003d.component.html',
  styleUrls: ['./sgkz003d.component.scss'],
})
export class Sgkz003dComponent implements OnInit, OnDestroy {
  /**
   * 画面表示項目
   * @type {CompleteData}
   * @memberof Sgkz003dComponent
   */
  gamenData: CompleteData = {
    title: '',
    message: '',
    next: '',
    koumokuList: []
  };

  /** 閉じるボタン・OKボタンの、表示非表示を管理するフラグ */
  closeButtonFlg = false;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /**
   * Creates an instance of Sgkz003dComponent.
   * @param {Router} router
   * @param {Router} completeDataService
   * @memberof Sgkz003dComponent
   */
  constructor(private router: Router, private completeDataService: CompleteDataService) { }

  /**
   * コンポーネント破棄処理
   * CompleteDataServiceをクリアする
   * @memberof Sgkz003dComponent
   */
  ngOnDestroy(): void {
    this.completeDataService.initializeData();
  }

  /**
   * コンポーネント生成処理
   * 前画面から渡された情報を元に画面を生成する
   * @memberof Sgkz003dComponent
   */
  ngOnInit(): void {

    // 完了画面データの購読設定
    this.completeDataService.valueChange
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        this.gamenData = data;
        this.closeButtonFlg = data.next === '' ||
          data.next === undefined ||
          data.next === null;
      });
  }

  /**
   * OKボタン押下時に次画面に遷移する
   * @memberof Sgkz003dComponent
   */
  onClickOk(): void {
    const { next, queryParams } = this.gamenData;

    if (this.closeButtonFlg) {
      window.close();
    } else if (queryParams === undefined || queryParams === null) {
      this.router.navigate([next]);
    } else {
      this.router.navigate([next, queryParams]);
    }
  }

}
